import React from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast, Bounce } from "react-toastify";


export default function UpgradeWithoutPayment({ plan, clientData, plan_amount }) {
  const navigate = useNavigate();

  const getDataFromlocalStorage = (key) => {
    try {
      const data = localStorage.getItem(key);
      return data ? JSON.parse(data) : null;
    } catch {
      return null;
    }
  };

  const saveDataTolocalStorage = (key, data) => {
    try {
      localStorage.setItem(key, JSON.stringify(data));
    } catch (err) {
      console.error("Failed to save to localStorage", err);
    }
  };

  const handleSaveSubscription = async () => {
    const user = getDataFromlocalStorage("userData");
    if (!user) {
      toast.error("User data not found!");
      return;
    }

    try {
      const response = await axios.post(
        window.CARLOCA_API + "/upgrade-dealer",
        {
          user_id: user?.id,
          amount: (clientData?.amount_paid / 100 > 0) ? plan_amount : parseFloat(plan?.price) + plan?.vat,
          car_limit: plan?.carLimit,
          type: plan?.period + "ly",
          plan_code: plan?.code,
          pay_id: clientData?.invoice_id,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response?.data?.status) {
        toast.success("Subscription upgraded successfully!", {
          transition: Bounce,
          theme: "colored",
        });

        const existingData = JSON.parse(localStorage.getItem("userData")) || {};
        const updatedData = { ...existingData, ...response?.data?.user };
        if (existingData.token) updatedData.token = existingData.token;
        saveDataTolocalStorage("userData", updatedData);

        navigate("/dealer/success", {
          state: {
            payment_id: clientData?.invoice_id,
            amount: (clientData?.amount_paid / 100 > 0) ? plan_amount : parseFloat(plan?.price) + plan?.vat,
            invoice_url: clientData?.invoice_url,
          },
        });
      } else {
        toast.error("Upgrade succeeded, but saving failed!");
      }
    } catch (error) {
      console.error("Upgrade error:", error);
      toast.error("Error saving subscription upgrade!");
    }
  };

  return (
    <div className="text-center">
      <div className="card p-4">
        <h5 className="text-success fw-bold">You've Already Subscribed to Our Plan!</h5>

        <p className="text-muted">
          You have already subscribed to the top plan. The plan amount was automatically deducted from your wallet (Stripe).
        </p>

        <p className="text-secondary">
          Amount Paid from Wallet: <strong>£{parseFloat(plan?.price) + plan?.vat}</strong>
        </p>

        <br />
        <button
          className="btn btn-success px-4 animated-button"
          onClick={handleSaveSubscription}
        >
          Confirm & Save Subscription
        </button>

      </div>
    </div>

  );
}
